import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "grid-content text-xl font-bold" }, "Update Product", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-base font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Information")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Title:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Handle:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Personalize:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Created:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "card-header flex justify-between items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Artworks")
], -1)
const _hoisted_9 = { class: "flex order-item-artwork" }
const _hoisted_10 = { class: "card-header flex justify-between items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Product variants", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-project-diagram mr-1" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("  Mapping ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" }, " ", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Export variants ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-retweet" }, " ", -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Sync to item ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-header text-base font-bold" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mockup")
], -1)
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "flex items-center justify-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }),
  /*#__PURE__*/_createTextVNode("  Confirm ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete product ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_25 = { class: "dialog-footer" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("  Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_save_button = _resolveComponent("save-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ProductVariants = _resolveComponent("ProductVariants")!
  const _component_close_button = _resolveComponent("close-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_sectionLayoutContent = _resolveComponent("sectionLayoutContent")!

  return (_openBlock(), _createBlock(_component_sectionLayoutContent, _mergeProps(_ctx.content, {
    backPageTitle: "Back",
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_skeleton, {
                    rows: 12,
                    animated: true
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_row, {
            key: 1,
            gutter: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { gutter: 24 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createVNode(_component_save_button, { onClick: _ctx.updateProduct }, null, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 18,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    header: _withCtx(() => [
                      _hoisted_3
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        class: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.product.title,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.product.title) = $event)),
                                placeholder: "Title"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        class: "mt-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.product.handle,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.product.handle) = $event)),
                                placeholder: "Handle",
                                disabled: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        class: "mt-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.product.personalized,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.product.personalized) = $event)),
                                placeholder: "Status"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Regular",
                                    value: false
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Personalized",
                                    value: true
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, {
                        gutter: 20,
                        class: "mt-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.product.createdDate)), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _hoisted_8
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.artworkSpaces, (artwork) => {
                          return (_openBlock(), _createBlock(_component_el_col, {
                            span: 5,
                            class: "p-1 order-artwork h-100",
                            key: artwork
                          }, {
                            default: _withCtx(() => [
                              (_ctx.product[artwork])
                                ? (_openBlock(), _createBlock(_component_UploadImage, {
                                    key: 0,
                                    setData: _ctx.product,
                                    data: _ctx.product[artwork],
                                    multiple: false,
                                    permission: "read",
                                    class: "border order-artwork-upload"
                                  }, null, 8, ["setData", "data"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_card, { class: "mt-3" }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_button, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (
                    _ctx.router.push({
                      path: `/s/mapping-product/${_ctx.product._id}`,
                    })
                  )),
                            type: "primary",
                            size: "small",
                            hidden: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _hoisted_13
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, { onClick: _ctx.confirmExportOrder }, {
                            default: _withCtx(() => [
                              _hoisted_14,
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            onClick: _ctx.syncToOrderItem,
                            loading: _ctx.isSyncToItem
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _hoisted_17
                            ]),
                            _: 1
                          }, 8, ["onClick", "loading"])
                        ])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_ProductVariants, {
                        documents: _ctx.product.variants,
                        onCallback: _ctx.callBackVariants,
                        onCallbackUpdateVarCode: _ctx.callbackUpdateVarCode
                      }, null, 8, ["documents", "onCallback", "onCallbackUpdateVarCode"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 6,
                class: "mt-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_card, null, {
                    header: _withCtx(() => [
                      _hoisted_18
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_UploadImage, {
                          setData: _ctx.product,
                          data: _ctx.product.mockup,
                          multiple: false,
                          onCallback: _ctx.callbackMockup
                        }, null, 8, ["setData", "data", "onCallback"])
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_UploadImage, {
                          setData: _ctx.product,
                          data: _ctx.product.otherMockup,
                          content: "",
                          multiple: true,
                          onCallback: _ctx.callbackOtherMockup
                        }, null, 8, ["setData", "data", "onCallback"])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                class: "my-3"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_close_button, {
                      onClick: _ctx.discardProduct,
                      label: "Discard"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_save_button, { onClick: _ctx.updateProduct }, null, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_dialog, {
                modelValue: _ctx.dialog,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
                width: "40%"
              }, {
                title: _withCtx(() => [
                  _hoisted_22
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("span", _hoisted_25, [
                    _createVNode(_component_el_button, { onClick: _ctx.cancelDelete }, {
                      default: _withCtx(() => [
                        _hoisted_26,
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.confirmDelete
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28,
                        _hoisted_29
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, [
                    _hoisted_23,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.product.title), 1),
                    _hoisted_24
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 16))
}